const md5 = require('../../../../utils/md5');
const BaseView = require('./abstract/template');
const DesignFacade = require('../../../../facade/design/design');
const ProjectFacade = require('../../../../facade/project/project');

module.exports = BaseView.extend({
  height: null,
  template: require('./templates/template.hbs'),

  events: {
    'click .base': 'addEvent',
    'click .options li[data-type="new-page"]': 'addToNewPageEvent',
    'click .options li[data-type="this-page"]': 'addToThisPageEvent'
  },

  addEvent: function (event) {
    this.setTemplate();
  },

  addToNewPageEvent: function (event) {
    event.stopPropagation();
    this.setOnNewPage();
  },

  addToThisPageEvent: function (event) {
    event.stopPropagation();
    this.setTemplate();
  },

  setOnNewPage: function () {
    ProjectFacade.handle('design', 'add', { quiet: true }).then(this.setTemplate);
  },

  setTemplate: function () {
    this.editor.loadingElement(1);
    DesignFacade.once(
      'template.update.restricted',
      () => {
        this.editor.loadingElement(0);

        function afterTemplateImagesLoaded () {
          INKIVE.DesignFacade.trigger('template.update.template_applied_on_current_page');
        }

        // TODO: Replace setTimeout with an image load listener
        setTimeout(afterTemplateImagesLoaded, 5000);
      }
    );

    DesignFacade.set('template', {
      restricted: {
        keep_permissions: true,
        page: this.pageNumber + 1,
        id: this.baseTemplate.encoded_id
      }
    });
  },

  initialize: function (options) {
    _.bindAll(this, 'setTemplate', 'setOnNewPage');

    BaseView.prototype.initialize.call(this);

    this.width = options.width;
    this.format = options.format;
    this.pageNumber = options.pageNumber;
    this.baseTemplate = options.template;
    this.canChangePageOrder = options.canChangePageOrder;

    this.render();
    this.initImageLoad(this.$el.find('.base'));
  },

  getTemplateRenderData: function () {
    const ratio = this.format.width / this.format.height;
    const thumbHeight = this.width * (1 / ratio);
    const page = this.baseTemplate.pages[this.pageNumber];

    return {
      url: getThumbnailURL.call(this),
      page_id: page.design_id,
      show_options: this.canChangePageOrder,
      thumb_height: Math.floor(thumbHeight)
    };

    function getThumbnailURL () {
      const encodedDesign = md5(page.design_id);
      const bucketUrl = INKIVE.Helpers.getBucketUrl(this.baseTemplate.master_bucket);

      return bucketUrl +
        '/344/' + this.baseTemplate.encoded_id +
        '/' + encodedDesign + '.jpg' +
        '?' + page.last_mod;
    }
  },

  initImageLoad: function ($container) {
    $container.find('img').each(function () {
      this.onload = onImageLoad;
      this.src = $(this).data('src');
    });

    function onImageLoad () {
      $(this).removeAttr('height')
        .closest('.thumbnail.image')
        .removeClass('loading');
    }
  }
});
